export const iconSize = 24;
